<div *ngIf="!images.length" class="flex min-h-[220px] w-full flex-col items-center justify-center gap-3 rounded-[18px] bg-gray-50 px-6 py-12 text-center" role="status">
  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#928a9b" stroke-width="1.4" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="3"/><circle cx="8" cy="8" r="1.5"/><path d="m3 17 5-5 4 4 3-3 6 6"/></svg>
  <p class="text-sm text-gray-500">Photos not available for this property</p>
</div>

<!-- ================================================================
     MEDIA TEMPLATE
================================================================ -->

<ng-template #mediaTemplate let-item>

  <!-- IMAGE -->
  <img
    *ngIf="item.type === 'image'"
    [src]="item.src"
    (error)="onImageError($event)"
    alt="Property image"
    class="block w-full h-full object-cover object-center select-none"
  />

  <!-- VIDEO -->
  <div
    *ngIf="item.type === 'video'"
    class="relative w-full h-full overflow-hidden"
  >

    <video
      [src]="item.src"
      muted
      preload="metadata"
      playsinline
      class="block w-full h-full object-cover object-center">
    </video>

    <!-- PLAY -->
    <div
      class="absolute inset-0 flex items-center justify-center pointer-events-none"
    >
      <div
        class="flex items-center justify-center w-12 h-12 md:w-14 md:h-14 rounded-full bg-black/60 border border-white/30 text-white text-base md:text-lg shadow-xl"
      >
        ▶
      </div>
    </div>

  </div>

</ng-template>


<!-- One or two items fill a single row without reserving thumbnail rows. -->
<div
  *ngIf="images.length > 0 && images.length <= 2"
  class="grid w-full gap-2 md:h-[360px] lg:h-[420px] xl:h-[460px]"
  [class.grid-cols-1]="images.length === 1"
  [class.grid-cols-2]="images.length === 2"
>
  <button
    *ngFor="let item of images; let index = index"
    type="button"
    class="relative block aspect-video w-full min-w-0 overflow-hidden rounded-[18px] bg-gray-100 cursor-pointer md:aspect-auto md:h-full md:min-h-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#7439e6]"
    [attr.aria-label]="(item.type === 'video' ? 'Play property video ' : 'View property image ') + (index + 1)"
    (click)="openLightbox(index)"
  >
    <ng-container
      [ngTemplateOutlet]="mediaTemplate"
      [ngTemplateOutletContext]="{ $implicit: item }">
    </ng-container>
  </button>
</div>

<ng-container *ngIf="images.length > 2">
<!-- ================================================================
     DESKTOP GALLERY
================================================================ -->

<div class="hidden md:block w-full">

  <div
    class=" property-gallery-desktop
      flex
      w-full
      h-[360px]
      lg:h-[420px]
      xl:h-[460px]
      gap-2
      rounded-[22px]
      bg-white
    "
  >

    <!-- ============================================================
         MAIN IMAGE
    ============================================================= -->

    <div
      *ngIf="desktopImages[0] as item"
      class="
        relative
        w-1/2
        h-full
        min-w-0
        overflow-hidden
        cursor-pointer
        rounded-xl
      "
      (click)="openLightbox(0)"
    >

      <ng-container
        [ngTemplateOutlet]="mediaTemplate"
        [ngTemplateOutletContext]="{ $implicit: item }">
      </ng-container>

    </div>


    <!-- ============================================================
         RIGHT SIDE
    ============================================================= -->

    <div
      class="
        flex
        flex-col
        w-1/2
        h-full
        min-w-0
        gap-2
      "
    >

      <!-- TOP ROW -->
      <div class="flex w-full h-1/2 min-h-0 gap-2">

        <!-- IMAGE 2 -->
        <div
          *ngIf="desktopImages[1] as item"
          class="
            relative
            w-1/2
            h-full
            min-w-0
            overflow-hidden
            cursor-pointer
            rounded-xl
          "
          (click)="openLightbox(1)"
        >

          <ng-container
            [ngTemplateOutlet]="mediaTemplate"
            [ngTemplateOutletContext]="{ $implicit: item }">
          </ng-container>

        </div>


        <!-- IMAGE 3 -->
        <div
          *ngIf="desktopImages[2] as item"
          class="
            relative
            w-1/2
            h-full
            min-w-0
            overflow-hidden
            cursor-pointer
            rounded-xl
          "
          (click)="openLightbox(2)"
        >

          <ng-container
            [ngTemplateOutlet]="mediaTemplate"
            [ngTemplateOutletContext]="{ $implicit: item }">
          </ng-container>

        </div>

      </div>


      <!-- BOTTOM ROW -->
      <div class="flex w-full h-1/2 min-h-0 gap-2">

        <!-- IMAGE 4 -->
        <div
          *ngIf="desktopImages[3] as item"
          class="
            relative
            w-1/2
            h-full
            min-w-0
            overflow-hidden
            cursor-pointer
            rounded-xl
          "
          (click)="openLightbox(3)"
        >

          <ng-container
            [ngTemplateOutlet]="mediaTemplate"
            [ngTemplateOutletContext]="{ $implicit: item }">
          </ng-container>

        </div>


        <!-- VIEW MORE -->
        <div
          *ngIf="images.length > 4"
          class="
            relative
            w-1/2
            h-full
            min-w-0
            overflow-hidden
            cursor-pointer
            rounded-xl
            bg-black
          "
          (click)="openLightbox(4)"
        >

          <!-- BACKGROUND IMAGE -->
          <ng-container *ngIf="desktopImages[4] as item">

            <ng-container
              [ngTemplateOutlet]="mediaTemplate"
              [ngTemplateOutletContext]="{ $implicit: item }">
            </ng-container>

          </ng-container>


          <!-- DARK OVERLAY -->
          <div
            class="
              absolute
              inset-0
              flex
              flex-col
              items-center
              justify-center
              bg-black/55
              text-white
              pointer-events-none
            "
          >

            <span class="text-base lg:text-lg font-semibold">
              View More
            </span>

            <span class="mt-1 text-xs lg:text-sm text-white/80">
              +{{ remainingCount }} Items
            </span>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>



<!-- ================================================================
     MOBILE GALLERY
================================================================ -->

<div
  class="
    flex
    md:hidden
    flex-col
    w-full
    gap-2
    overflow-hidden
    rounded-[18px]
  "
>

  <!-- ============================================================
       MAIN IMAGE
  ============================================================= -->

  <div
    *ngIf="mobileImages[0] as item"
    class="
      relative
      w-full
      h-[220px]
      min-h-[220px]
      overflow-hidden
      rounded-[18px]
      bg-gray-100
      cursor-pointer
    "
    (click)="openLightbox(0)"
  >

    <ng-container
      [ngTemplateOutlet]="mediaTemplate"
      [ngTemplateOutletContext]="{ $implicit: item }">
    </ng-container>

  </div>


  <!-- ============================================================
       BOTTOM TWO IMAGES
  ============================================================= -->

  <div
    class="
      flex
      w-full
      h-[115px]
      min-h-[115px]
      gap-2
    "
  >

    <!-- IMAGE 2 -->
    <div
      *ngIf="mobileImages[1] as item"
      class="
        relative
        flex-1
        w-1/2
        h-full
        min-w-0
        overflow-hidden
        rounded-[14px]
        bg-gray-100
        cursor-pointer
      "
      (click)="openLightbox(1)"
    >

      <ng-container
        [ngTemplateOutlet]="mediaTemplate"
        [ngTemplateOutletContext]="{ $implicit: item }">
      </ng-container>

    </div>


    <!-- IMAGE 3 + MORE -->
    <div
      *ngIf="mobileImages[2] as item"
      class="
        relative
        flex-1
        w-1/2
        h-full
        min-w-0
        overflow-hidden
        rounded-[14px]
        bg-gray-100
        cursor-pointer
      "
      (click)="openLightbox(2)"
    >

      <ng-container
        [ngTemplateOutlet]="mediaTemplate"
        [ngTemplateOutletContext]="{ $implicit: item }">
      </ng-container>


      <!-- MORE OVERLAY -->

      <div
        *ngIf="images.length > 3"
        class="
          absolute
          inset-0
          flex
          flex-col
          items-center
          justify-center
          bg-black/55
          text-white
          pointer-events-none
        "
      >

        <span class="text-lg font-bold">
          +{{ remainingCountMobile }}
        </span>

        <span class="mt-0.5 text-xs text-white/85">
          Items
        </span>

      </div>

    </div>

  </div>

</div>


</ng-container>
